/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useMemo, useRef } from 'react';

import Button from '@/components/tangerina/Button';
import { formatDateHelper } from '@/helpers/formatDateHelper';
import { formatNumber } from '@/helpers/StringHelper/formatNumber';

export type TProps = {
  template: string;
  cards: {
    type: 'card';
    header_1?: string;
    header_2?: string;
    header_icon?: string;
    image: {
      image: {
        url: string;
      };
    };
    card_text?: {
      text?: string;
      subtexto?: string;
      tag_text?: string;
      tag_color?: string;
      card_text_icon?: string;
      image: {
        url: string;
      };
    }[];
    card_text_text?: string;
    card_link: {
      label: string;
      link: string;
      channel: string;
    };
    tags_config?: [
      {
        min_value: string;
        max_value: string;
        text: string;
        color: string;
      },
    ];
    card_text_tag_text?: string;
    card_text_tag_color?: string;
  };
};

export default function Card({ template, cards }: TProps) {
  const prefixTemplateClass = `vitrine-template${template}`;

  const cardRef = useRef<HTMLDivElement>(null);

  const [
    destinationObj,
    originObj,
    dateObj,
    flightTypeObj,
    fromLabelObj,
    milesObj,
    updatedAtObj,
    disclaimerObj,
  ] = cards.card_text || [];

  const cardInfo = {
    destination: destinationObj?.text,
    origin: originObj?.text,
    originIcon: originObj?.image?.url,
    date: dateObj?.text,
    dateIcon: dateObj?.image?.url,
    flightType: flightTypeObj?.text,
    fromLabel: fromLabelObj?.text,
    miles: milesObj?.text,
    milesSubtext: milesObj?.subtexto,
    tagText: milesObj?.tag_text,
    tagColor: milesObj?.tag_color,
    updatedAt: updatedAtObj?.text,
    disclaimer: disclaimerObj?.text,
  };

  const handleButtonClick = () => {
    if (window.openModal) {
      window.openModal(cardRef.current as HTMLElement);
    }
  }

  const purchaseUrl = useMemo(() => {
    const airportFrom = cards.header_1 || null;
    const airportTo = cards.header_2 || null;

    const flightDateStr = cards.card_text?.[2]?.text || null;
    let flightDate: number | null = null;
    if (flightDateStr) {
      const dateParts = flightDateStr.split('-');
      if (dateParts.length === 3) {
        const dateObj = new Date(
          Number(dateParts[0]),
          Number(dateParts[1]) - 1,
          Number(dateParts[2]),
          12,
          0,
          0,
          0
        );

        flightDate = dateObj.getTime();
      }
    }

    return `?originAirport=${airportFrom}&destinationAirport=${airportTo}&departureDate=${flightDate}&isFlexibleDateChecked=false`;
  }, [cards.header_1, cards.header_2, cards.card_text?.[2]?.text]);

  return (
    <div className={`${prefixTemplateClass}__card`} ref={cardRef} data-purchase-url={purchaseUrl}>
      <img
        src={cards.image.image.url}
        className={`${prefixTemplateClass}__card--image`}
        alt="title"
      />
      <div className={`${prefixTemplateClass}__card--header`}>
        <span className={`${prefixTemplateClass}__card--header1`}>
          {cards.header_1}
        </span>
        <img src={cards.header_icon} alt={cards.card_text_text} />
        <span className={`${prefixTemplateClass}__card--header2`}>
          {cards.header_2}
        </span>
      </div>
      <div className={`${prefixTemplateClass}__card--group1`}>
        <p className={`${prefixTemplateClass}__card--group1__destination`}>{cardInfo.destination}</p>
        <div className={`${prefixTemplateClass}__card--group1__origin`}>
          <img src={cardInfo.originIcon} alt="origin icon" />
          <p>{cardInfo.origin}</p>
        </div>
        <div className={`${prefixTemplateClass}__card--group1__date`}>
          <img src={cardInfo.dateIcon} alt="origin icon" />
          <p>{formatDateHelper(cardInfo.date)}</p>
        </div>
        <p className={`${prefixTemplateClass}__card--group1__flight-type`}>{cardInfo.flightType}</p>
      </div>
      <div className={`${prefixTemplateClass}__card--group2`}>
        <div className={`${prefixTemplateClass}__card--group2__inner`}>
          <p className={`${prefixTemplateClass}__card--group2__from-label`}>{cardInfo.fromLabel}</p>
          <p className={`${prefixTemplateClass}__card--group2__miles`}>
            <strong>
              {cardInfo.miles ? formatNumber(cardInfo.miles) : cardInfo.miles}
            </strong>
            <span className={`${prefixTemplateClass}__card__tag--club`}>
              {cardInfo.tagText}
            </span>
          </p>
          <small className={`${prefixTemplateClass}__card--group2__miles-subtext`}>{cardInfo.milesSubtext}</small>
        </div>
        <p className={`${prefixTemplateClass}__card--group2__updated-at`}>{cardInfo.updatedAt}</p>
        <p className={`${prefixTemplateClass}__card--group2__disclaimer`}>{cardInfo.disclaimer}</p>
        <Button appearance="primary" onClick={handleButtonClick}>{cards.card_link?.label}</Button>
      </div>
    </div>
  );
}
